import * as Api from '@ViewModels';
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { actionItemQueryKeys } from './actionItemQueryKeys';
import { buildOpenActionItemsFilter } from './useOpenActionItemsQuery';

const PAGE_SIZE = 50;

export function useCompletedActionItemsQuery({
	assignedTo,
	search,
	contactId,
	impersonationContext,
	enabled = true,
}: {
	assignedTo: string | undefined;
	search: string;
	contactId?: string | null;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IPagedCollection<Api.IActionItem>>({
		enabled,
		placeholderData: keepPreviousData,
		queryKey: actionItemQueryKeys.completed(assignedTo, search.trim(), impersonationContext?.account?.id, contactId),
		queryFn: ({ pageParam }) =>
			userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.IActionItem>>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: {
						currentUserOnly: false,
						pageSize: PAGE_SIZE,
						pageToken: pageParam,
						sortBy: 'completionDate',
						sort: 'desc',
					},
					urlPath: 'actionItem/filter',
				}),
				'POST',
				buildOpenActionItemsFilter({ assignedTo, search, completed: true, contactId })
			),
		getNextPageParam: lastPage => lastPage.pageToken || undefined,
		initialPageParam: '',
		meta: { toastErrorMessage: 'Failed to load completed action items' },
	});
}
